<div class="radish">
	<router-outlet></router-outlet>
</div>
